import {StyleSheet} from 'react-native';

export default StyleSheet.create({
    container: {
        flex: 1,
    },
    browserPreview:{
        marginLeft:5,
        color:'#999999'
    },
    logo: {
        width: 120,
        height: 120,
        marginTop: '35%',
    },
    icons:{
        width:20,
        height:20,
        flex:1,
        marginTop:7
    },
    title: {
        fontFamily: 'Raleway',
        fontSize: 28,
        fontWeight: 'bold',
    },
    instructions:{
        fontFamily: 'Raleway',
        fontWeight:'400',
        flex:2,
        color:'#999999',
        fontSize:16,
        marginVertical:15
    },
    installText:{
        fontFamily: 'Raleway',
        fontWeight:'400',
        color:'#ffffff'
    }
});
